import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/RoofingCalculator/roofingCalculator.container"
    ).then((module) => ({
        default: module.RoofingCalculator
    }))
);
